<template>
  <div id="app">
    <!-- <HeaderM  :class="{show:HeaderMShow}" @menushow2="menushow2" /> -->
    <div id="page">
      <first-Component></first-Component>
      <home-Component></home-Component>
      <!-- <foot></foot> -->
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import firstComponent from "@/components/first.vue";
// import foot from "@/components/foot.vue";
import homeComponent from "@/views/home.vue";
// import { setTimeout } from "timers";
export default {
  name: "home",
  data() {
    return {
      loader: true,
      loading: false,
      noShow: {},
      wow: "",
      scrollbar: "",
      HeaderMShow: false,
    };
  },
  // watch:{
  //   '$route':'init'
  // },
  components: { firstComponent, homeComponent },
  mounted() {
    this.wow = new WOW();
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.wow.init();
        this.wow.scrollHandler();
      });
    },
  },
};
</script>
<style>
/*.fp-section{*/
/*  transition: all 600ms;*/
/*  opacity: .8;*/
/*  !*transform: translate(30%,100%);*!*/
/*  !*transform: translateY(100%);*!*/
/*}*/
/*.fp-completely{*/
/*  opacity: 1 !important;*/
/*  transform: translateY(0) !important;*/
/*}*/
.fp-auto-height.fp-section,
.fp-auto-height .fp-slide,
.fp-auto-height .fp-tableCell,
.fp-responsive .fp-auto-height-responsive.fp-section,
.fp-responsive .fp-auto-height-responsive .fp-slide,
.fp-responsive .fp-auto-height-responsive .fp-tableCell {
  height: auto !important;
}
body,*{
  margin: 0;
  padding: 0;
  font-family: inherit;
}
ul,
li,
p,
a {
  margin: 0;
  padding: 0;
  text-decoration: none;
  color: black;
}
input:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}
textarea:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
  resize: none !important;
}
.donghua {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  color: white;
  background-color: black;
  animation-duration: 600ms;
  animation-delay: 100ms;
}
#app {
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow: hidden;
}
#page {
  transition: 0.4s;
  position: relative;
  z-index: 102;
}
.fullpage-wrapper {
}
/*#page.menushow{*/
/*  transform: translate(0,50vh);*/
/*}*/
#scroller-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
  /* z-index: 101; */
}
.scrollbar-thumb {
  width: 3px !important;
  background-color: #98a48e !important;
}
.scrollbar-track-y {
  width: 3px !important;
}
.fp-left {
  position: fixed;
  top: 50%;
  left: 50px;
  z-index: 1000;
}
.fp-left ul li {
  list-style: none;
  margin: 20px 0;
}
.fp-left ul li a span:nth-child(1) {
  display: none;
}
.fp-left ul li a span:nth-child(2) {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: white;
  position: relative;
  border-radius: 50%;
}
.fp-left ul li .active span:nth-child(2)::after {
  display: inline-block;
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 18px;
  height: 18px;
  border: 1px solid white;
  border-radius: 50%;
  transition: all 300ms;
  animation: point 600ms;
}
@keyframes point {
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }

}
</style>
